import React from "react";
import { ATTEST_WAITING } from "domains/programs/constants";
import {
  CompletedChip,
  TeamsChip,
  RequestedChip,
  AttestChip,
  AdministratorChip,
} from "Components/Module/LearningActivityItem/Chips";

export const OnlineCourseChips = ({ course, completed, languageContext }) => {
  const isConnectedToMicrosoftTeams = Boolean(course.microsoftTeamId);
  const isAdministrator = Boolean(Number(course.profileId) < 3);

  return (
    <>
      {completed && <CompletedChip label={languageContext("completed")} />}
      {isConnectedToMicrosoftTeams && !completed && (
        <TeamsChip label={languageContext("connectedToTeams")} />
      )}
      {course.requested && (
        <RequestedChip label={languageContext("courserequested")} />
      )}
      {course.attestStatus === ATTEST_WAITING && !completed && (
        <AttestChip label={languageContext("waitingforattest")} />
      )}
      {isAdministrator && (
        <AdministratorChip label={languageContext("administrator")} />
      )}
    </>
  );
};

export const ClassroomCourseChips = ({
  course,
  completed,
  languageContext,
}) => {
  const isConnectedToMicrosoftTeams = Boolean(course.microsoftTeamId);
  const isAdministrator = Boolean(Number(course.profileId) < 3);
  return (
    <>
      {completed && <CompletedChip label={languageContext("completed")} />}
      {isConnectedToMicrosoftTeams && !completed && (
        <TeamsChip label={languageContext("connectedToTeams")} />
      )}
      {course.requested && (
        <RequestedChip label={languageContext("courserequested")} />
      )}
      {course.attestStatus === ATTEST_WAITING && !completed && (
        <AttestChip label={languageContext("waitingforattest")} />
      )}
      {isAdministrator && (
        <AdministratorChip label={languageContext("administrator")} />
      )}
    </>
  );
};

export const ProgramChips = ({ program, completed, languageContext }) => {
  const isConnectedToMicrosoftTeams = Boolean(program.microsoftTeamId);
  const isAdministrator = Boolean(Number(program.profileId) < 3);
  return (
    <>
      {!completed && isConnectedToMicrosoftTeams && (
        <TeamsChip label={languageContext("connectedToTeams")} />
      )}
      {completed && <CompletedChip label={languageContext("completed")} />}
      {program.requested && (
        <RequestedChip label={languageContext("programrequested")} />
      )}
      {!completed && program.attestStatus === ATTEST_WAITING && (
        <AttestChip label={languageContext("waitingforattest")} />
      )}
      {isAdministrator && (
        <AdministratorChip label={languageContext("administrator")} />
      )}
    </>
  );
};
